export default __webpack_public_path__ + "static/media/ui_store_experience_bundle_02.4650ea4f.png";